import { $t } from '@/i18n';
import { CUSTOM_HOST_CONFIG, EXTERNAL_DEPLOY, HAS_OTHER_AUTH_SERVICE, IS_SHOW_XIAOMAN, IS_SHOW_AEGIS, IS_SHOW_AGENT_REPORT, OPEN_DESIGNER_DEPLOY, OPEN_WUJI_NAVIGATOR, } from '@config/constant';
const projectInfo = $t('k_95610e57');
const version = $t('k_e852b234');
const auth = $t('k_eb8e4960');
const report = $t('k_506326d2');
const permission = $t('k_f5ed4e00');
const setting = $t('k_dbeaa94e');
export const PAGES = {
    pageList: {
        englishName: ['pageList'],
        name: [$t('k_fb10ca0')],
        path: '/pagelist',
        keys: {
            addPage: $t('k_4f007a55'),
            labelManage: $t('k_686d8fb2'),
        },
    },
    basic: {
        englishName: ['projectInfo', 'basic'],
        name: [projectInfo, $t('k_98aed9be')],
        path: '/basic',
        keys: {
            id: $t('k_295efc94'),
            name: $t('k_20cba5c'),
            desc: $t('k_409f2431'),
            projectType: $t('k_9ff5ee55'),
            productId: $t('k_5a4ecbd5'),
            admin: $t('k_9d32cc23'),
            participant: $t('k_263d97ff'),
            theme: $t('k_c193dc90'),
            skin: $t('k_9a83c869'),
            navStyle: $t('k_a7863779'),
            favicon: {
                title: $t('k_f9a1dc10'),
                desc: $t('k_3cc810ad'),
            },
            homePage: {
                title: $t('k_8a679250'),
                desc: $t('k_92841cb4'),
            },
            page403: {
                title: $t('k_ad62fe85'),
                desc: $t('k_a28cc400'),
            },
            hideLoadingIndicator: {
                title: $t('k_12b8abc6'),
                desc: $t('k_2c18c818'),
            },
            tipsStyle: {
                title: $t('k_49de27d7'),
                desc: $t('k_7cd6e7cc'),
            },
            showWatermark: {
                title: $t('k_24106a88'),
                desc: $t('k_e94bfcd9'),
            },
            xiaoman: {
                title: $t('k_cf117737'),
                desc: [
                    $t('k_f50a9b5a'),
                    $t('k_5b4ffd97'),
                    $t('k_31263a7f'),
                ],
            },
            aegis: {
                title: $t('k_c2d9342c'),
                desc: [
                    $t('k_59ee9f84'),
                    $t('k_552e0834'),
                ],
            },
            agentReport: {
                title: $t('k_c01eb690'),
                desc: [
                    $t('k_71a3695f'),
                    $t('k_114720f6'),
                ],
            },
            announcement: {
                title: $t('k_812ef8c4'),
                desc: $t('k_e859a2e0'),
            },
            customNav: {
                title: $t('k_d897b344'),
                desc: $t('k_ff847a4c'),
            },
            customSidebar: {
                title: $t('k_f89e924a'),
                desc: $t('k_25512510'),
            },
            customHeader: {
                title: $t('k_fcd32904'),
                desc: $t('k_11f715eb'),
            },
            customFooter: {
                title: $t('k_64c881e7'),
                desc: $t('k_a801cdc0'),
            },
            visibility: $t('k_2dfa9b23'),
        },
    },
    advance: {
        englishName: ['projectInfo', 'advance'],
        name: [projectInfo, $t('k_c05af489')],
        path: '/advance',
        keys: {
            customLayout: $t('k_6293d5c1'),
            routeGuard: $t('k_497ac1f1'),
            weworkApp: $t('k_82d3fe18'),
            projectLessCode: $t('k_e2880003'),
            globalScriptSetting: $t('k_65497236'),
            globalIcons: $t('k_996f55a6'),
            aegisConfig: $t('k_130a364d'),
        },
    },
    navbar: {
        englishName: ['navbar'],
        name: [$t('k_9a2ca24a')],
        path: '/navbar',
        keys: {
            user: $t('k_cd480ec5'),
            name: $t('k_1cba5fce'),
            projectLogo: $t('k_4e0f78e9'),
            env: $t('k_ac4e9d62'),
            help: $t('k_2f969c12'),
            feedback: $t('k_86ef7db0'),
            wujiNavigator: $t('k_5ab53ef0'),
            navFixTop: $t('k_ddc2a038'),
            showBreadcrumb: {
                title: $t('k_f7a98f36'),
                desc: $t('k_3a05b280')
                    + $t('k_70cc46df'),
            },
            showTagsView: {
                title: $t('k_f548632d'),
                desc: $t('k_5cb6d7c6'),
            },
            showNavWaterMark: {
                title: $t('k_ab70844c'),
                desc: $t('k_69f6080d'),
            },
            widgets: {
                title: $t('k_14dbc5e'),
                desc: $t('k_807b4485'),
            },
            bizIsolation: $t('k_bf012fb5'),
            menuGroup: $t('k_8f2c3513'),
            rightSelect: $t('k_6334a7d1'),
            navbarComponent: $t('k_e1073a27'),
            defaultAvatar: $t('k_c2e00121'),
            customAvatar: $t('k_5ab431da'),
            permission: $t('k_b9250eb'),
        },
    },
    sidebar: {
        englishName: ['sidebar'],
        name: [$t('k_8ed73419')],
        path: '/menu',
        keys: {
            width: $t('k_d6c15dbf'),
            menuConfig: $t('k_5bb33fd0'),
            withTitle: $t('k_2e41613a'),
            withMenuTitle: $t('k_d60bff84'),
            openAllSubMenu: $t('k_18e37385'),
            accordion: {
                title: $t('k_49afbf7c'),
                desc: $t('k_d2a1abd'),
            },
            withSearch: $t('k_6b48f43d'),
            menuSetting: $t('k_70789227'),
        },
    },
    workflow: {
        englishName: ['workflow'],
        name: [$t('k_3e0d1f1f')],
        path: '/workflow',
        keys: {},
    },
    flow: {
        englishName: ['flow'],
        name: [$t('k_b0bb41bb'), $t('k_4af63156')],
        path: '/flow',
        keys: {},
    },
    flowJob: {
        englishName: ['job'],
        name: [$t('k_9251baf8')],
        path: '/flow/job',
        keys: {},
    },
    flowConfig: {
        englishName: ['config'],
        name: [$t('k_485b2fe0')],
        path: '/flow/config',
        keys: {},
    },
    datasource: {
        englishName: ['datasource'],
        name: [$t('k_ccd9cc09')],
        path: '/collection/list',
        keys: {},
    },
    version: {
        englishName: ['version', 'versionRecord'],
        name: [version, $t('k_4a13fd75')],
        path: '/version',
        keys: {},
    },
    env: {
        englishName: ['version', 'env'],
        name: [version, $t('k_b6404365')],
        path: '/env',
        keys: {},
    },
    component: {
        englishName: ['component'],
        name: [$t('k_cb1523d3')],
        path: '/component',
        keys: {},
    },
    offline: {
        englishName: ['offline'],
        name: [$t('k_82815987')],
        path: '/offline',
        keys: {},
    },
    base: {
        englishName: ['auth', 'base'],
        name: [auth, $t('k_d170f433')],
        path: '/auth/base',
        keys: {
            authApp: $t('k_1f7cd3b0'),
            authComponentHub: $t('k_6e1950df'),
        },
    },
    secretKey: {
        englishName: ['auth', 'secretKey'],
        name: [auth, $t('k_b07f0e3c')],
        path: '/auth/secretkey',
        keys: {},
    },
    cos: {
        englishName: ['auth', 'projectCOS'],
        name: [auth, $t('k_eee091b6')],
        path: '/auth/cos',
        keys: {},
    },
    api: {
        englishName: ['auth', 'apiAuth'],
        name: [auth, $t('k_5d02d01')],
        path: '/auth/api',
        keys: {
            setAuthApi: $t('k_590055d5'),
            authCollectionId: {
                title: $t('k_e4f4daaf'),
                desc: $t('k_85ee44bd'),
            },
            permissionLink: $t('k_5a7180ee'),
        },
    },
    dslog: {
        englishName: ['report | dslog', 'dslog'],
        name: [report, $t('k_7d16762a')],
        path: '/dslog',
        keys: {},
    },
    role: {
        englishName: ['permission', 'role'],
        name: [permission, $t('k_be264c8b')],
        path: '/permission/role',
        keys: {},
    },
    user: {
        englishName: ['permission', 'user'],
        name: [permission, $t('k_66b1d735')],
        path: '/permission/user',
        keys: {},
    },
    customPermission: {
        englishName: ['permission', 'customPermission'],
        name: [permission, $t('k_fb75e62e')],
        path: '/permission/permission',
        keys: {},
    },
    apiPermission: {
        englishName: ['permission', 'apiPermission'],
        name: [permission, $t('k_3350e5ed')],
        path: '/permission/api',
        keys: {},
    },
    permissionAdvanceSetting: {
        englishName: ['permission', 'advanceSetting'],
        name: [permission, $t('k_708eae6')],
        path: '/permission/advance',
        keys: {},
    },
    announcement: {
        englishName: ['announcement'],
        name: [$t('k_812ef8c4'), $t('k_d42eb49e')],
        path: '/announcement',
        keys: {},
    },
    branch: {
        englishName: ['branch'],
        name: [$t('k_c6731ee3')],
        path: '/settings/branch',
        keys: {
            enabledBranch: {
                title: $t('k_9a7886ed'),
                desc: $t('k_28d0a7dd'),
            },
            protectBranch: {
                title: $t('k_2efbea3d'),
                desc: $t('k_74cb1461'),
            },
            branchRelatedEnv: {
                title: $t('k_c01afbef'),
                desc: $t('k_6c9c4aee'),
            },
        },
    },
    publish: {
        englishName: ['setting', 'publish'],
        name: [setting, $t('k_eb7c1610')],
        path: '/settings/publish',
        keys: {
            deleteProject: $t('k_d2d59602'),
            needStaging: {
                title: $t('k_20f429c'),
                desc: $t('k_6623f210'),
            },
            enabledProdVersionApproval: {
                title: $t('k_ed7085c7'),
                desc: $t('k_c317bdc6'),
            },
            devToProd: $t('k_375663fa'),
            pushHook: $t('k_9fa8e09a'),
        },
    },
    editor: {
        englishName: ['setting', 'editor'],
        name: [setting, $t('k_84b9b9d8')],
        path: '/settings/editor',
        keys: {
            eslintEnabled: {
                title: $t('k_71780009'),
                desc: $t('k_b88b8737'),
            },
            eslintConfig: {
                title: $t('k_cdc148dd'),
            },
        },
    },
};
export const UPDATE_PAGE = {
    projectUpdate: {
        englishName: ['projectUpdate'],
        name: ['应用更新'],
        path: '/subProject/update',
        keys: {},
    },
};
export const BRANCH_PAGE = {
    branch: {
        englishName: ['branch'],
        name: ['分支管理'],
        path: '/branch',
        keys: {},
    },
};
export const REPORT_PAGE = {
    report: {
        englishName: ['report | dslog', 'report'],
        name: [report, '上报分析'],
        path: '/report',
        keys: {},
    },
};
export const HOST_PAGE = {
    host: {
        englishName: ['setting', 'shortPath'],
        name: [setting, '短路径配置'],
        path: '/settings/host',
        keys: {},
    },
};
export const AUTH_PAGE = {
    AuthSetting: {
        englishName: ['setting', 'AuthSetting'],
        name: [setting, '鉴权设置'],
        path: '/permission/setting',
        keys: {},
    },
};
export const ADVANCE_PAGE = {
    advanceSetting: {
        englishName: ['setting', 'advanceSetting'],
        name: [setting, '其他'],
        path: '/settings/advance',
        keys: {},
    },
};
export const EDITOR_PAGE = {
    advanceSetting: {
        englishName: ['setting', 'editor'],
        name: [setting, '编辑器设置'],
        path: '/settings/editor',
        keys: {},
    },
};
export const EMAIL_SETTING_PAGE = {
    advanceSetting: {
        englishName: ['setting', 'email'],
        name: [setting, '邮箱配置'],
        path: '/settings/email',
        keys: {},
    },
};
export const OPEN_PAGE = {
    openNetwork: {
        englishName: ['setting', 'openNetwork'],
        name: [setting, '外网设置'],
        path: '/settings/open',
        keys: {},
    },
};
// 是否为可以显示的搜索项（如：小满反馈为外网不显示的配置项）
async function isIncludeKey(key, store) {
    const { hasDeptInfoService, isSuper } = await import('@utils/userInfo');
    const basicKeys = PAGES.basic.keys;
    const visibility = store.state.project.projectInfo?.visibility;
    const customLayouts = window.xy_custom_layouts || [];
    if (key === basicKeys.orgName && !hasDeptInfoService())
        return false;
    if (key === basicKeys.visibility && !(isSuper() || visibility === '1'))
        return false;
    if (key === basicKeys.xiaoman.title && !IS_SHOW_XIAOMAN)
        return false;
    if (key === basicKeys.aegis.title && !IS_SHOW_AEGIS)
        return false;
    if (key === basicKeys.agentReport.title && !IS_SHOW_AGENT_REPORT)
        return false;
    if (key === PAGES.navbar.keys.wujiNavigator && !OPEN_WUJI_NAVIGATOR)
        return false;
    if (key === PAGES.advance.keys.customLayout && customLayouts.length <= 0)
        return false;
    return true;
}
export async function searchConfig(input) {
    const result = [];
    const { useStore } = await import('@/store');
    const store = useStore();
    const enabledBranch = store.state.project.settings?.versionSetting?.enabledBranch;
    const haveParent = !!store.state.project.baseProjectInfo?.parentId;
    const needToSearchPages = {
        ...PAGES,
        ...(haveParent ? UPDATE_PAGE : {}),
        ...(enabledBranch ? BRANCH_PAGE : {}),
        ...(!EXTERNAL_DEPLOY ? REPORT_PAGE : {}),
        ...(CUSTOM_HOST_CONFIG ? HOST_PAGE : {}),
        ...(HAS_OTHER_AUTH_SERVICE ? AUTH_PAGE : {}),
        ...ADVANCE_PAGE,
        ...(OPEN_DESIGNER_DEPLOY ? OPEN_PAGE : {}),
    };
    const isMatched = (key) => {
        if (!key)
            return false;
        if (Array.isArray(key)) {
            return key.some(i => i.toLowerCase().includes(input.toLowerCase()));
        }
        return key.toLowerCase().includes(input.toLowerCase());
    };
    for (const page of Object.values(needToSearchPages)) {
        const englishName = page.englishName.join('/');
        const name = page.name.join('/');
        // 搜索一二级菜单
        if (isMatched(name)) {
            result.push({ path: page.path, englishName, chineseName: name, parentMenu: name });
        }
        // 搜索页面配置项
        for (const [key, value] of Object.entries(page.keys)) {
            const { title, desc } = typeof value === 'string' ? { title: value, desc: '' } : value;
            if (await isIncludeKey(title, store) && (isMatched(title) || isMatched(desc))) {
                result.push({ path: page.path, englishName: `${englishName}/${key}`, chineseName: title, parentMenu: `${name}/${title}` });
            }
        }
    }
    return result;
}
